<template>
  <el-table-column
    prop="quantity_unit"
    sortable="custom"
    label="Mennyiségi egység"
    show-overflow-tooltip
    min-width="180px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.quantity_unit">{{ getUnitLabel(scope.row.quantity_unit) }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
import measureUnits from '../../../../utils/measureUnits';

export default {
  propName: 'quantity_unit',
  data() {
    return {
      measureUnits,
    };
  },
  methods: {
    getUnitLabel(value) {
      const unit = this.measureUnits.find(unit => unit.value === value);
      return unit ? unit.label : value;
    }
  },
};
</script>
